import React, { useState, useEffect } from 'react';
import * as apiClient from "../../common/apiClient";
import { useNavigate } from 'react-router-dom';


import {
  HomeImageContainer
  , HomeContainer, HomeImage, HomeLoginContainer, FlexBox, LoginHeader, InputField,
  InputBox, LoginButton, EmptyBox, LoginButtonContainer
} from './styled';
import { Header } from '../../components/header/internals'
import Image from '../../assets/homeimage.svg'



export const Signup = (props:any) => {
  const [signupFields, setSignUpFields] = useState({ name: '', emailId: '', corporateCode: '', password: '', confirmPassword: '' })
  const [errorField, setErrorField] = useState<any>(null)
  const [isLoading, setIsLoading] = useState<any>(false);
  const navigate = useNavigate();
   
  const errorStyle = { 
    borderColor: 'red', 
  };
  const showToastMessage = (message: any) => {
    apiClient.showErrorMessage(message);
  };
  const showSuccessMessage = (message: any) => {
    apiClient.showSuccessMessage(message);
  };
  
  const handleOnChange = (event: any, identifier: any) => {
    let fields: any = { ...signupFields };
    fields[identifier] = event.target.value;
    setErrorField(null);
    setSignUpFields(fields);

  };

  const handleSubmit = () => {
    
    if (signupFields.name == null || signupFields.name == undefined || signupFields.name == '') {
      showToastMessage('Full Name is required');
      setErrorField("name");
      return;
    }
    if (signupFields.emailId == null || signupFields.emailId == undefined || signupFields.emailId == '') {
      showToastMessage('Email Id is required');
      setErrorField('emailId')
      return;
    }
    if (!apiClient.validateEmail(signupFields.emailId)) {
      showToastMessage('Please Enter Valid email');
      setErrorField('emailId')
      return;
    }
    if (signupFields.corporateCode == null || signupFields.corporateCode == undefined || signupFields.corporateCode == '') {
      showToastMessage('Corporate Code is required');
      setErrorField('corporateCode')
      return;
    }
    if (signupFields.password == null || signupFields.password == undefined || signupFields.password == '') {
      showToastMessage('Password is required');
      setErrorField('password')
      return;
    }
    if (signupFields.confirmPassword == null || signupFields.confirmPassword == undefined || signupFields.confirmPassword == '') {
      showToastMessage('Confirm Password is required');
      setErrorField('confirmPassword')
      return;
    }
    if (signupFields.confirmPassword != signupFields.password) {
      showToastMessage('Confirm Password is not matching with password');
      setErrorField('confirmPassword')
      return;
    }
    setIsLoading(true);
    
    let payload={
      name: signupFields.name,
      emailId:  signupFields.emailId,
      password:   signupFields.password,
      confirmPassword:   signupFields.confirmPassword,
      usertype: "business",
      corporateCode: signupFields.corporateCode,
    }
    apiClient.post('business-partners/register', payload,null).then((response: any) => {
      setIsLoading(false); 
      if(response.result)
      {
        showSuccessMessage(response.message);
        navigate('/home');    
      }
      else
      {
        showToastMessage(response.message);
      }
    }).catch((err) => {
      setIsLoading(false);
    })
  }

  return (
    <HomeContainer>
      <Header />
      <FlexBox >
        <HomeImageContainer>
          <HomeImage src={Image} />
        </HomeImageContainer>

        <HomeLoginContainer>
          <LoginHeader>
            Register yourself
          </LoginHeader>
          <InputField style={errorField=='name'?errorStyle:{}} >
            <InputBox type="text" placeholder='Enter Full Name' value={signupFields.name} onChange={(event) => handleOnChange(event, 'name')}  ></InputBox>
          </InputField>
          <InputField style={errorField=='emailId'?errorStyle:{}} >
            <InputBox type="text" placeholder='Enter Email ID' value={signupFields.emailId} onChange={(event) => handleOnChange(event, 'emailId')}  ></InputBox>
          </InputField>
          <InputField style={errorField=='corporateCode'?errorStyle:{}} >
            <InputBox type="text" placeholder='Corporate Code' value={signupFields.corporateCode} onChange={(event) => handleOnChange(event, 'corporateCode')}></InputBox>
          </InputField>
          <InputField style={errorField=='password'?errorStyle:{}} >
            <InputBox type="password" placeholder='Password' value={signupFields.password} onChange={(event) => handleOnChange(event, 'password')} ></InputBox>
          </InputField>
          <InputField style={errorField=='confirmPassword'?errorStyle:{}} >
            <InputBox type="password" placeholder='Confirm Password' value={signupFields.confirmPassword} onChange={(event) => handleOnChange(event, 'confirmPassword')}></InputBox>
          </InputField>

          <EmptyBox />
          <LoginButtonContainer>
            <LoginButton disabled={isLoading} onClick={handleSubmit} >Submit</LoginButton>
          </LoginButtonContainer>
        </HomeLoginContainer>

      </FlexBox>

    </HomeContainer>
  );
};
